export default {
    authenticated: state => {
        return ![undefined, null, ""].includes(state.token);
    },
    currentTime: () => Math.floor(Date.now() / 1000),
}